import React, { Component } from 'react';
import { connect } from 'react-redux'
import PropTypes from 'prop-types';

import { Spin, Icon } from 'antd';

import { serverGetJobs } from '../actions';


const antIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;

class NextJob extends Component {
    constructor(props){
        super(props);
        this.timeout = null;
    }
    componentDidMount(){
        this.timeout = setTimeout(() => {
            this.props.nextJob();
        }, 500);
    }
    componentWillUnmount(){
        clearTimeout(this.timeout);
        this.timeout = null;
    }
    render() {
        return (
            <div style={{ textAlign: 'center', verticalAlign: 'center', paddingTop: '20%' }}>
                <Spin indicator={antIcon} />
            </div>
        );
    }
}

NextJob.propTypes = {
    nextJob: PropTypes.func,
};

const mapStateToProps = () => ({
});

const mapDispatchToProps = (dispatch) => ({
    nextJob: () => {
        dispatch(serverGetJobs());
    },
});

const NextJobContainer = connect(mapStateToProps,mapDispatchToProps)(NextJob);
export default NextJobContainer;



// WEBPACK FOOTER //
// ./src/validation/components/NextJob.js